import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Crm
import CrmReducer from "./crm/reducer";

//Logistic Companies
import CompaniesReducer from "./companies/reducer";

//Containers
import ContainersReducer from "./containers/reducer";

//Additional Fees
import AdditionalFeesReducer from "./additionalfees/reducer";

//Various Fees
import VFeesReducer from "./vfees/reducer";

//Receivers
import ReceiversReducer from "./receivers/reducer";

//Vehicles
import VehiclesReducer from "./vehicles/reducer";

//Orders
import OrdersReducer from "./orders/reducer";

//Quotes
import QuotesReducer from "./quotes/reducer";

//Invoices
import InvoicesReducer from "./invoice/reducer";

//MInvoices
import MInvoicesReducer from "./minvoices/reducer";

//Order Invoices
import OrderInvoicesReducer from "./orderinvoice/reducer";

//Documents
import DocumentsReducer from "./documents/reducer";

//Requests
import RequestsReducer from "./requests/reducer";

//Warehouse
import WarehousesReducer from "./warehouses/reducer";

//Notifications
import NotificationsReducer from "./notifications/reducer";

//Landing
import LandingReducer from "./landing/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Company: CompaniesReducer,
  Container: ContainersReducer,
  AddFee: AdditionalFeesReducer,
  VFee: VFeesReducer,
  Receiver: ReceiversReducer,
  Vehicle: VehiclesReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Crm: CrmReducer,
  Order: OrdersReducer,
  Invoice: InvoicesReducer,
  OrderInvoice: OrderInvoicesReducer,
  Document: DocumentsReducer,
  UserRequest: RequestsReducer,
  MInvoice: MInvoicesReducer,
  Warehouse: WarehousesReducer,
  Notification: NotificationsReducer,
  Quote: QuotesReducer,
  Landing: LandingReducer,
});

export default rootReducer;
